import { useCallback } from 'react';

import { Button } from '@bambi/component-library/src/components/Button/Button';
import { SimpleTooltip } from '@bambi/component-library/src/components/Tooltip/SimpleTooltip';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';

import { useAppDispatch } from 'src/app/store/hooks';
import { MembershipRead } from 'src/common/external/bambi-api/bambiApi';
import { UserTypeBadge } from 'src/common/UserTypeBadge/UserTypeBadge';

import {
  setSelectedMemberProfile,
  setShowProfileTypeSelectModal,
} from '../team.slice';

export function AssociateBadge({ membership }: { membership: MembershipRead }) {
  const dispatch = useAppDispatch();
  const showWarning =
    !membership.has_attendant_profile && !membership.has_driver_profile;

  const handleOpen = useCallback(() => {
    dispatch(setSelectedMemberProfile(membership));
    dispatch(setShowProfileTypeSelectModal(true));
  }, [dispatch, membership]);

  return (
    <div className="relative w-[75px]">
      <UserTypeBadge userType="associate" />
      {showWarning ? (
        <SimpleTooltip
          trigger={
            <div className="absolute bottom-[-7px] right-[-15px]">
              <Button variant="ghost-icon" onClick={handleOpen}>
                <ExclamationCircleIcon className="h-6 w-6 fill-yellow-500 stroke-white" />
              </Button>
            </div>
          }
          content="No driver or attendant profile. Click to set up."
        />
      ) : null}
    </div>
  );
}
